import React from 'react';
import { useTheme } from '../../../core/ui/ThemeContext';
import { useLanguage } from '../../../core/i18n/LanguageContext';

const WebsiteSettings = ({ generalSettings, setGeneralSettings }) => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();

  return (
    <div className="relative group mb-6">
      <div className={`absolute inset-0 ${isDarkMode
        ? 'bg-gradient-to-br from-gray-900/30 via-gray-800/20 to-gray-900/30 border border-white/20'
        : 'glass-light-card border border-slate-200'
      } ${isDarkMode ? 'backdrop-blur-2xl' : ''} rounded-3xl ${isDarkMode ? 'shadow-[0_8px_32px_rgba(0,0,0,0.4)]' : 'shadow-sm'}`}></div>
      <div className={`absolute inset-0 ${isDarkMode
        ? 'bg-gradient-to-t from-white/5 via-transparent to-white/10'
        : ''
      } rounded-3xl`}></div>
                
      <div className="relative p-6">
        <h4 className={`text-lg font-semibold ${isDarkMode ? 'text-white drop-shadow-lg' : 'text-slate-900'} mb-6`}>{t('admin.website.title')}</h4>
        <div>
          <label className={`block text-sm font-semibold ${isDarkMode ? 'text-white drop-shadow-lg' : 'text-slate-700'} mb-3`}>{t('admin.website.siteTitle')}</label>
          <div className="relative group/input">
            <div className={`absolute inset-0 ${isDarkMode ? 'bg-gray-800/30 border border-white/30 backdrop-blur-xl shadow-[inset_0_1px_0_rgba(255,255,255,0.2)]' : 'bg-white border border-slate-200'} rounded-2xl`}></div>

            <input
              type="text"
              value={generalSettings.siteTitle}
              onChange={(e) => setGeneralSettings({...generalSettings, siteTitle: e.target.value})}
              className={`relative w-full px-4 py-4 bg-transparent border-0 rounded-2xl focus:ring-2 ${isDarkMode ? 'focus:ring-blue-400/50' : 'focus:ring-brand/40'} focus:outline-none transition-all duration-300 ${isDarkMode ? 'text-white placeholder-white/60 focus:shadow-[0_0_20px_rgba(59,130,246,0.4)] hover:shadow-[0_0_15px_rgba(255,255,255,0.2)]' : 'text-slate-900 placeholder-slate-400'}`}
              placeholder="SAP OCI Portal"
            />

            <div className={`absolute inset-0 rounded-2xl border border-transparent ${isDarkMode ? 'group-focus-within/input:border-blue-400/50' : 'group-focus-within/input:border-brand/40'} transition-all duration-300 pointer-events-none`}></div>
          </div>
          <p className={`text-sm ${isDarkMode ? 'text-white/60 drop-shadow-sm' : 'text-slate-600'} mt-2`}>{t('admin.website.siteTitleHint')}</p>
        </div>
      </div>
    </div>
  );
};

export default WebsiteSettings;